import { motion } from "framer-motion";
import { Instagram, Facebook, Youtube, Music2, ExternalLink } from "lucide-react";
import SectionHeading from "@/components/SectionHeading";
import { socialCards } from "@/data/content";

const iconMap = {
  instagram: Instagram,
  facebook: Facebook,
  youtube: Youtube,
  tiktok: Music2,
};

export default function Social() {
  return (
    <section id="redes" data-testid="social-section" className="bg-white py-20 sm:py-28 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12">
        <SectionHeading
          chapter="08"
          kicker="Redes sociais"
          title="Siga a campanha de perto"
          description="Agenda pública, bastidores e conversas com a comunidade — acompanhe nas redes. Perfis oficiais em breve."
        />

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {socialCards.map((s, i) => {
            const Icon = iconMap[s.icon];
            return (
              <motion.div
                key={s.name}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ delay: i * 0.08, duration: 0.55 }}
                data-testid={`social-card-${s.icon}`}
                className="flex flex-col rounded-3xl border border-slate-200 bg-slate-50 p-6 transition-all duration-200 hover:-translate-y-2 hover:shadow-xl"
              >
                <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-brand-royal to-brand-dark text-white">
                  <Icon className="h-6 w-6" />
                </div>
                <h3 className="font-display text-lg font-bold text-slate-900">{s.name}</h3>
                <p className="text-sm font-semibold text-brand-royal">{s.handle}</p>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-slate-600">{s.desc}</p>
                <a
                  href={s.url || "#redes"}
                  {...(s.url ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                  data-testid={`social-follow-${s.icon}`}
                  aria-label={`Seguir no ${s.name} (perfil oficial em breve)`}
                  className="mt-4 inline-flex items-center gap-2 self-start rounded-full border border-brand-royal/30 px-4 py-2 text-sm font-bold text-brand-royal transition-colors hover:bg-brand-royal hover:text-white"
                >
                  Seguir <ExternalLink className="h-3.5 w-3.5" />
                </a>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
